<script>
    import {
        Modal,
        BackDrop,
        Button,
        ScrollBox,
        Typography,
        CheckBox,
        Alert,
        TailSpinner,
    } from '$lib/components/UI'
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    export let show
    export let buttonLabel = 'Enviar solicitud'
    let aceptoTerminos
    let waiting = false
    function onSend() {
        waiting = true
        try {
            dispatch('send')
        } catch (_) {
            waiting = false
        }
    }
</script>

<BackDrop
    style="padding-top: 70px;position: fixed; top: 0; z-index: var(--lvl-2);"
    visible={show}
>
    <Modal
        title="Terminos y condiciones"
        subtitle="Por favor lea los terminos y condiciones de uso"
        on:clickout={(_) => {
            if (!waiting) show = false
        }}
        on:close={(_) => {
            if (!waiting) show = false
        }}
        justifyButtons="space-between"
        closeable={!waiting}
    >
        <span slot="buttonSet" class="buttonSet">
            <CheckBox
                label="He leido y acepto los terminos."
                style="justify-self:left"
                bind:checked={aceptoTerminos}
                disabled={waiting}
            />
            <Button
                size="small"
                on:click={onSend}
                disabled={!aceptoTerminos || waiting}
            >
                {#if waiting}
                    <TailSpinner size={20} />
                {/if}
                {buttonLabel}
            </Button>
            <!-- label="Enviar solicitud" -->
        </span>
        <ScrollBox width="100%" height="220px">
            <Typography type="legend">
                El Proveedor declara conocer y aceptar que los datos de carácter
                personal que fueron proporcionados en ocasión al registro
                "Portal de Proveedores" de La Caja, serán tratados de acuerdo a
                la ley 25.326 y tendrán el carácter de declaración jurada. Los
                datos serán incorporados y tratados en una base de datos, la
                cual se encuentra registrada en la Agencia de Acceso a la
                Información Pública, cuyo destinatario y titular es La Caja.
                <br /><br />
                El Proveedor tiene el derecho de acceso a los mismos en forma gratuita,
                de acuerdo a lo que establece en el artículo 14, inciso 3 de la Ley
                25.326.
                <br /><br />
                La AGENCIA DE ACCESO A LA INFORMACIÓN PUBLICA, Órgano de Control
                de la Ley Nº 25.326, está facultado para atender las denuncias y
                reclamos que se inicien con relación al incumplimiento de las normas
                sobre protección de datos personales.
            </Typography>
        </ScrollBox>
        {#if waiting}
            <Alert type="error"
                >Por favor no cierre la pestaña del navegador.</Alert
            >
        {/if}
        <!-- <div
        style="display: flex; width: 100%; position: relative; flex-direction: row; justify-content:space-between; align-items: center"
      >
    </div> -->
    </Modal>
</BackDrop>

<style>
    .buttonSet {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 25px;
    }
</style>
